import React from 'react'
import { Link, Text, View, StyleSheet, Image } from '@react-pdf/renderer'
import ExternalLinkGenerator from '../../../../../smallComponents/ExternalLinkGenerator'

const PF = process.env.REACT_APP_PUBLIC_FOLDER

// roboto refers to Arabic

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderBottomWidth: 2,
    borderBottomColor: '#112131',
    borderBottomStyle: 'solid',
    alignItems: 'center',
    marginBottom: 10,
    padding: 10,
  },
  detailColumn: {
    flexDirection: 'column',
    flexGrow: 9,
    textTransform: 'uppercase',
    marginLeft: 10,
  },
  linkColumn: {
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexGrow: 2,
  },
  name: {
    fontSize: 20,
    fontFamily: 'Lato',
    marginBottom: 4,
  },
  nameArabic: {
    fontSize: 20,
    fontFamily: 'Roboto',
    marginBottom: 4,
  },
  date: {
    fontSize: 10,
    fontFamily: 'Lato',
    marginBottom: 5,
    color: '#6c757d',
  },
  dateArabic: {
    fontSize: 10,
    fontFamily: 'Roboto',
    marginBottom: 5,
    color: '#6c757d',
  },
  url: {
    fontSize: 9,
    fontFamily: 'Roboto',
    color: 'blue',
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '60%',
    textTransform: 'none',
    lineHeight: '1em',
  },
  logo: {
    width: 80,
    height: 80,
    objectFit: 'contain',
  },
  link: {
    fontFamily: 'Lato',
    fontSize: 10,
    color: 'black',
    textDecoration: 'none',
  },
  linkArabic: {
    fontFamily: 'Roboto',
    fontSize: 10,
    color: 'black',
    textDecoration: 'none',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    fontFamily: 'Lato',
    bottom: 0,
    right: 0,
    paddingBottom: 10,
    paddingRight: 10,
  },
  pageNumberArabic: {
    position: 'absolute',
    fontSize: 10,
    fontFamily: 'Roboto',
    bottom: 0,
    right: 0,
    paddingBottom: 10,
    paddingRight: 10,
  },
})

function isArabic(text) {
  return /[\u0600-\u06FF]/.test(text)
}

export default ({ title, element }) => {
  const elementLink = decodeURIComponent(ExternalLinkGenerator(element))
  return (
    <View fixed style={{ top: 0 }}>
      <View style={styles.container}>
        <Image src={`${PF}HutupiaSub.png`} style={styles.logo} />
        <View style={styles.detailColumn}>
          <Text style={[styles.name, isArabic(title) && styles.nameArabic]}>
            {title}
          </Text>
          <Text
            style={[
              styles.date,
              isArabic(new Date().toLocaleString()) && styles.dateArabic,
            ]}
          >
            {new Date().toLocaleString()}
          </Text>
          {element?.hashTagType !== 'projectMarketingStrategy' &&
            element?.hashTagType !== 'projectBusinessModel' &&
            element?.hashTagType !== 'managerialplan' && (
              <Link href={elementLink} style={styles.url}>
                {elementLink}
              </Link>
            )}
        </View>
        <View style={styles.linkColumn}>
          <Link href='https://www.hutupia.com' style={styles.link}>
            Hutupia.com
          </Link>
        </View>
      </View>
    </View>
  )
}
